function disableScroll() {
  var x = window.scrollX;
  var y = window.scrollY;
  window.onscroll = function () { window.scrollTo(x, y) };
}
function enableScroll() {
  window.onscroll = null;
}

export const menuButton = () => {
  let menuButton = document.getElementById("menuButton")
  let menuResponsive = document.getElementsByClassName("responsive-menu")[0]
  let header = document.querySelector("header")
  let linkContact = document.getElementsByClassName("menu__link")[5]
  menuButton.addEventListener("click", function () {
    menuResponsive.classList.toggle("open")
    this.classList.toggle("open")
    if (this.classList.contains("open"))
      disableScroll()
    else {
      enableScroll()
    }
  })
  menuResponsive.addEventListener("click", function () {
    enableScroll()
    menuResponsive.classList.remove("open")
    menuButton.classList.remove("open")
  })
}
